var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11 1-9 9.5 9 9.5",
    stroke: "#000",
    strokeOpacity: 0.46,
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgChevron;